import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Mumbaitoahmednagarcab() {



const cardData = {
  keyword: "Mumbai to Ahmednagar Cab",

headingDescription:
  "Omshree Cab offers safe and comfortable Mumbai to Ahmednagar cab services for travelers planning a hassle-free journey to this historic city in Maharashtra. Whether you are traveling for business, family visits, weekend trips, or group tours, our cab service ensures a smooth and convenient ride with experienced drivers and well-maintained vehicles. We provide flexible booking options including one-way, round-trip, and multi-day travel plans at transparent per-kilometer pricing. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and tempo travelers suitable for solo travelers, families, and groups. With professional chauffeurs skilled in long-distance and highway driving, punctual pickups from anywhere in Mumbai, and 24/7 customer support, Omshree Cab is your trusted partner for Mumbai to Ahmednagar cab services.",

topPlaces: [
  {
    title: "Ahmednagar Fort",
    description:
      "Ahmednagar Fort is a historic fort built in the 15th century, known for its impressive architecture and historical significance during the Mughal and Maratha eras. Visitors can explore the fort’s walls, gates, and bastions while enjoying panoramic views of the surrounding city. Traveling by cab ensures comfortable access, allowing tourists to spend sufficient time exploring the fort without worrying about local transport or parking."
  },
  {
    title: "Shani Shingnapur",
    description:
      "Shani Shingnapur is a famous pilgrimage village near Ahmednagar, dedicated to Lord Shani. The unique temple has no doors on houses, showcasing strong faith in the deity. Devotees visit to perform rituals, seek blessings, and experience the local culture. A cab ride provides convenient travel from Mumbai, ensuring sufficient time to explore the temple, village, and nearby attractions comfortably."
  },
  {
    title: "Sundarvan Zoo and Park",
    description:
      "Sundarvan Zoo and Park is a family-friendly destination in Ahmednagar, featuring a variety of animals, landscaped gardens, and recreational spaces. Visitors can enjoy leisurely walks, photography, and picnics. Traveling by cab allows visitors to reach the park conveniently and plan a relaxed outing along with other city attractions without transport concerns."
  },
  {
    title: "Bhandardara Dam & Arthur Lake",
    description:
      "Bhandardara Dam and Arthur Lake, located near Ahmednagar, are popular for their scenic beauty, boating, and nature walks. The surrounding hills and forests offer a peaceful retreat. A cab ride ensures comfortable access, making it easy to explore the dam, lake, and nearby attractions at leisure without worrying about local commuting."
  },
  {
    title: "Harishchandragad Fort",
    description:
      "Harishchandragad Fort is a historic hill fort near Ahmednagar, popular for trekking, panoramic views, and ancient temples. Visitors can enjoy trekking trails, photography, and cultural exploration. Using a cab allows travelers to reach the base comfortably, plan their trek efficiently, and include this fort in a day trip from Ahmednagar."
  },
  {
    title: "Karanjgaon Ganesh Temple",
    description:
      "Karanjgaon Ganesh Temple is a local religious site in Ahmednagar, attracting devotees for prayers and rituals. The temple offers a peaceful environment and traditional architecture. Traveling by cab ensures easy access, allowing visitors to include the temple in a city sightseeing or pilgrimage itinerary."
  },
  {
    title: "Famous Local Markets",
    description:
      "Ahmednagar’s local markets offer shopping for handicrafts, textiles, traditional items, and local snacks. Visitors can experience the local culture and cuisine while buying souvenirs. A cab ride allows comfortable travel between markets and other attractions, making it easy to explore the city efficiently."
  },
  {
    title: "Kopargaon Ganesh Temple",
    description:
      "Kopargaon Ganesh Temple is a revered spiritual site near Ahmednagar, attracting devotees from across the region. Visitors can perform rituals, offer prayers, and enjoy the tranquil surroundings. Traveling by cab provides convenient access, making it possible to plan multiple temple visits in a single day without transport hassles."
  },
  {
    title: "Shirdi Sai Baba Temple (Nearby)",
    description:
      "Shirdi Sai Baba Temple is a world-famous pilgrimage site located near Ahmednagar, visited by millions of devotees annually. Pilgrims can participate in aarti, explore the temple complex, and experience spiritual solace. A cab ride from Mumbai ensures a comfortable journey, flexible schedule, and seamless integration with other Ahmednagar sightseeing spots."
  },
  {
    title: "Ralegan Siddhi",
    description:
      "Ralegan Siddhi is a model village near Ahmednagar known for its environmental initiatives and social development programs led by Anna Hazare. Visitors can explore the village, learn about sustainable practices, and enjoy the peaceful rural environment. Traveling by cab provides comfortable access and allows sufficient time to explore this unique destination along with other nearby attractions."
  }
],




services: [
{
name: "Mumbai to Ahmednagar Cab",
description: "Mumbai to Ahmednagar cab service offers a comfortable and reliable travel solution for passengers planning intercity travel between Mumbai and Ahmednagar. Our fleet includes clean AC sedans, SUVs, and premium vehicles that ensure a smooth highway journey. Professional drivers with strong route knowledge guarantee safe and timely travel. Pickup is available from homes, hotels, offices, railway stations, and Mumbai airport terminals. This service is ideal for business trips, family travel, temple visits, and sightseeing journeys. Spacious seating and air-conditioned interiors provide a relaxed travel experience. Flexible travel scheduling allows passengers to plan trips conveniently. Transparent pricing and professional service ensure a stress-free cab booking experience."
},
{
name: "Mumbai to Ahmednagar Taxi",
description: "Mumbai to Ahmednagar taxi service provides convenient and affordable transportation for passengers traveling between the two cities. Comfortable AC vehicles ensure smooth travel across highways and city routes. Experienced drivers guarantee safe driving and timely arrival at the destination. Pickup is available across Mumbai including homes, offices, hotels, and airport terminals. Ideal for family travel, corporate trips, and outstation journeys. Clean interiors and spacious seating ensure a pleasant travel experience. Flexible departure timing allows travelers to schedule their journey easily. Reliable taxi services ensure comfortable and safe travel from Mumbai to Ahmednagar."
},
{
name: "Mumbai to Ahmednagar Cab Service",
description: "Mumbai to Ahmednagar cab service offers dependable transportation for travelers looking for safe and convenient road travel. Our well-maintained AC vehicles ensure a smooth and comfortable highway journey. Experienced chauffeurs ensure professional driving and punctual travel schedules. Pickup services are available from residential areas, hotels, offices, and Mumbai airport terminals. This service is ideal for tourists, families, and corporate travelers. Spacious vehicles provide comfortable seating for long-distance journeys. Flexible travel options allow passengers to plan trips easily. Transparent pricing ensures a reliable cab service without hidden charges."
},
{
name: "Mumbai to Ahmednagar Taxi Service",
description: "Mumbai to Ahmednagar taxi service is designed to provide efficient and reliable intercity travel for passengers. Our fleet of clean AC vehicles ensures a comfortable journey through major highway routes. Skilled drivers with local route knowledge ensure safe and timely travel. Pickup is available from homes, hotels, offices, and Mumbai airport terminals. Ideal for family trips, corporate travel, and weekend journeys. Spacious seating ensures passengers travel comfortably throughout the trip. Flexible booking options make scheduling travel easy. Affordable fares ensure a convenient and stress-free taxi service."
},
{
name: "Cab from Mumbai to Ahmednagar",
description: "Cab from Mumbai to Ahmednagar offers a private and comfortable travel option for passengers traveling between these two cities. AC vehicles ensure a smooth highway journey and pleasant travel experience. Professional drivers provide safe driving and ensure timely arrival. Pickup is available from any location across Mumbai including homes, offices, and airport terminals. Ideal for business trips, family travel, and religious visits. Spacious seating ensures comfort for long-distance journeys. Flexible travel timing allows passengers to schedule trips conveniently. Reliable cab services ensure safe and comfortable travel."
},
{
name: "Taxi from Mumbai to Ahmednagar",
description: "Taxi from Mumbai to Ahmednagar offers dependable transportation for travelers seeking comfortable road travel. Our AC vehicles ensure relaxed highway journeys and pleasant travel conditions. Experienced drivers ensure safe driving and smooth navigation along major routes. Pickup is available from homes, hotels, offices, and airports across Mumbai. Ideal for family travel, business visits, and long-distance trips. Clean interiors and spacious seating ensure passenger comfort. Flexible departure options help travelers plan their trip easily. Professional taxi service ensures reliable travel between Mumbai and Ahmednagar."
},
{
name: "Mumbai to Ahmednagar Cab Booking",
description: "Mumbai to Ahmednagar cab booking allows travelers to reserve vehicles quickly and conveniently for outstation travel. Online and phone booking options provide instant confirmation and easy scheduling. Comfortable AC vehicles ensure smooth highway travel. Professional drivers ensure safe and punctual travel experiences. Pickup is available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for business travel, family trips, and tourist journeys. Flexible one-way and round-trip booking options are available. Reliable cab booking service ensures smooth travel planning."
},
{
name: "Mumbai to Ahmednagar Taxi Booking Online",
description: "Mumbai to Ahmednagar taxi booking online provides a quick and easy reservation system for passengers planning their trip. Instant booking confirmation ensures convenient travel planning. AC sedans and SUVs provide comfortable travel throughout the journey. Experienced drivers ensure safe and professional highway driving. Pickup is available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for tourists, families, and corporate travelers. Flexible scheduling allows passengers to choose convenient travel times. Reliable online booking ensures hassle-free taxi reservations."
},
{
name: "Mumbai to Ahmednagar Cab Price",
description: "Mumbai to Ahmednagar cab price offers transparent and affordable travel options for passengers planning intercity journeys. Clear pricing ensures customers understand travel costs before booking. Our fleet includes sedans, SUVs, and premium vehicles suited for different travel needs. Comfortable seating and AC interiors ensure relaxed travel throughout the journey. Professional drivers ensure safe highway travel. Pickup services are available across Mumbai including airport terminals. Flexible travel options allow passengers to choose one-way or round-trip journeys. Budget-friendly pricing ensures reliable and affordable cab service."
},
{
name: "Mumbai to Ahmednagar Taxi Fare",
description: "Mumbai to Ahmednagar taxi fare is calculated with transparent per-kilometer pricing to ensure fair and clear travel costs. Travelers can choose from sedan, SUV, and premium vehicles depending on their comfort preference. Our AC vehicles ensure smooth highway travel between cities. Experienced drivers guarantee safe driving and timely arrival. Pickup services are available from homes, hotels, offices, and airports across Mumbai. Ideal for family travel and business trips. Flexible booking options allow convenient trip planning. Reliable fare structure ensures stress-free taxi booking."
},
{
name: "Mumbai to Ahmednagar One Way Cab",
description: "Mumbai to Ahmednagar one way cab service is ideal for passengers who require a drop service without paying return charges. This option helps reduce overall travel expenses while ensuring comfortable transportation. AC sedans and SUVs offer relaxed seating for long-distance travel. Professional drivers ensure safe and smooth highway driving. Pickup is available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for business travel and quick intercity trips. Flexible scheduling allows convenient departure times. Reliable one-way cab service ensures comfortable and affordable travel."
},
{
name: "Mumbai to Ahmednagar Round Trip Taxi",
description: "Mumbai to Ahmednagar round trip taxi service offers complete travel convenience for passengers planning return journeys. Flexible return scheduling allows travelers to complete meetings, sightseeing, or visits comfortably. AC vehicles ensure relaxed travel during long-distance trips. Professional drivers remain available for return travel according to passenger schedules. Pickup services are available across Mumbai including homes, offices, hotels, and airport terminals. Ideal for family travel, corporate visits, and weekend trips. Spacious vehicles ensure comfort for group travel. Reliable round-trip taxi service ensures smooth travel planning."
},
{
name: "Mumbai to Ahmednagar Innova Cab",
description: "Mumbai to Ahmednagar Innova cab service provides spacious and comfortable travel for families and group passengers. The premium MPV offers ample seating space and luggage capacity for long-distance journeys. AC interiors ensure relaxed travel throughout the trip. Experienced drivers ensure safe highway driving and smooth travel. Pickup is available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for family trips and corporate travel. Comfortable seating ensures a pleasant travel experience. Reliable Innova cab service ensures convenient outstation travel."
},
{
name: "Mumbai to Ahmednagar Ertiga Cab",
description: "Mumbai to Ahmednagar Ertiga cab service offers comfortable travel for medium-sized families and small groups. Spacious seating and AC interiors ensure relaxed highway travel. Professional drivers ensure safe and smooth driving between cities. Pickup services are available from homes, offices, hotels, and airport terminals across Mumbai. Ideal for family vacations and business travel. Well-maintained vehicles ensure reliable long-distance journeys. Flexible travel options allow convenient scheduling. Reliable Ertiga cab service ensures comfortable intercity travel."
},
{
name: "Mumbai to Ahmednagar Sedan Cab",
description: "Mumbai to Ahmednagar sedan cab service provides an affordable and comfortable travel option for passengers. Sedans are perfect for individuals, couples, and small families traveling between cities. AC interiors ensure pleasant travel conditions throughout the journey. Experienced drivers ensure safe and professional highway driving. Pickup is available from homes, hotels, offices, and airports across Mumbai. Ideal for business travel and quick outstation trips. Flexible booking options allow convenient scheduling. Reliable sedan cab service ensures smooth and economical travel."
},
{
name: "Mumbai to Ahmednagar SUV Taxi",
description: "Mumbai to Ahmednagar SUV taxi service is ideal for larger families and group travelers requiring spacious seating. SUVs offer excellent comfort, luggage capacity, and stable highway performance. AC interiors ensure relaxed travel for long-distance journeys. Professional drivers ensure safe and smooth highway driving. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for group trips, family travel, and corporate outings. Comfortable seating ensures a pleasant journey. Reliable SUV taxi service ensures safe and convenient travel."
}
],

tableData: [
["Mumbai to Ahmednagar Cab","Mumbai to Ahmednagar Taxi"],
["Mumbai to Ahmednagar Cab Service","Mumbai to Ahmednagar Taxi Service"],
["Cab from Mumbai to Ahmednagar","Taxi from Mumbai to Ahmednagar"],
["Mumbai to Ahmednagar Cab Booking","Mumbai to Ahmednagar Taxi Booking Online"],
["Mumbai to Ahmednagar Cab Price","Mumbai to Ahmednagar Taxi Fare"],
["Mumbai to Ahmednagar One Way Cab","Mumbai to Ahmednagar Round Trip Taxi"],
["Mumbai to Ahmednagar Innova Cab","Mumbai to Ahmednagar Ertiga Cab"],
["Mumbai to Ahmednagar Sedan Cab","Mumbai to Ahmednagar SUV Taxi"]
],




whychoose: [
  {
    WhyChooseheading: "Experienced Highway Drivers",
    WhyChoosedescription: "Our drivers are highly experienced with the Mumbai to Ahmednagar highway routes. They understand the fastest and safest roads connecting Mumbai, Pune, and Ahmednagar, ensuring a smooth and comfortable journey for passengers."
  },
  {
    WhyChooseheading: "Transparent Pricing",
    WhyChoosedescription: "Omshree Cabs offers clear and transparent pricing for Mumbai to Ahmednagar cab services. We share the complete fare details, toll charges, and travel package in advance so customers never face hidden costs."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Whether you need an early morning departure or late-night travel, Omshree Cabs provides round-the-clock cab booking support. Our team ensures reliable service anytime for Mumbai to Ahmednagar travel."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "Our fleet includes well-maintained and fully air-conditioned vehicles designed for long-distance journeys. Each car is regularly cleaned and sanitized so passengers enjoy a hygienic and comfortable ride."
  },
  {
    WhyChooseheading: "Flexible Travel Options",
    WhyChoosedescription: "We offer flexible trip options including one-way cabs, round trips, and same-day return packages. Travelers can customize the pickup time and route according to their travel plans."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Omshree Cabs offers a wide range of vehicles including sedan cars, spacious SUVs like Ertiga and Innova, and premium vehicles suitable for family or group travel."
  },
  {
    WhyChooseheading: "Doorstep Pickup from Mumbai",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, and airports anywhere in Mumbai. Our drivers arrive on time so your journey to Ahmednagar begins smoothly and without travel hassle."
  },
  {
    WhyChooseheading: "Reliable & Punctual Service",
    WhyChoosedescription: "Omshree Cabs is known for dependable service and punctual pickups. Our drivers prioritize passenger safety and ensure you reach Ahmednagar comfortably and on time."
  }
]
};

const faqData = [
  { question: "What is the distance from Mumbai to Ahmednagar by cab?", answer: "The distance from Mumbai to Ahmednagar is approximately 260 km and the journey usually takes around 5–6 hours depending on traffic and road conditions." },
  { question: "Do you provide one-way Mumbai to Ahmednagar cab services?", answer: "Yes, Omshree Cabs provides both one-way and round-trip cab services between Mumbai and Ahmednagar." },
  { question: "Which vehicles are available for Mumbai to Ahmednagar travel?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, and premium vehicles depending on your group size and comfort preference." },
  { question: "Is pickup available from Mumbai Airport?", answer: "Yes, we provide direct pickup from Mumbai Airport for Ahmednagar cab bookings." },
  { question: "Can we visit Shirdi during the Ahmednagar trip?", answer: "Yes, many travelers combine Ahmednagar travel with Shirdi Sai Baba Temple visits, and our drivers are familiar with the route." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, every vehicle provided by Omshree Cabs is fully air-conditioned for comfortable travel." },
  { question: "Can we stop during the journey for food or rest?", answer: "Yes, passengers can request stops during the journey for meals, refreshments, or rest breaks." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during weekends and festival seasons." },
  { question: "Do you offer round-trip packages?", answer: "Yes, Omshree Cabs offers round-trip and multi-day travel packages for Ahmednagar trips." },
  { question: "Are vehicles sanitized before travel?", answer: "Yes, all vehicles are cleaned and sanitized regularly to maintain passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rahul Deshmukh",
    feedback:
      "We booked Omshree Cabs for a Mumbai to Ahmednagar trip. The driver was very professional and the car was clean and comfortable. Great service overall.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Kavita Shah",
    feedback:
      "Our family journey from Mumbai to Ahmednagar with Omshree Cabs was smooth and stress-free. On-time pickup and transparent pricing made the trip excellent.",
    rating: 5
  }
];























































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Ahmednagar Cab",
  "description": "Book Mumbai to Ahmednagar Cab with Omshree Cab for safe and comfortable outstation travel. Choose from Innova, Ertiga, Sedan, and SUV taxis for one-way or round trips. Affordable fares, easy online cab booking, and reliable taxi service from Mumbai to Ahmednagar.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2200"
  }
};








  return (
    <div>
      
<Helmet>
  <title>Mumbai to Ahmednagar Cab | Contact: +91 9892544084 | Omshree Cab</title>
  <meta 
    name="description" 
    content="Book Mumbai to Ahmednagar Cab with Omshree Cab for comfortable travel. Taxi service with Innova, Ertiga, Sedan, and SUV options for one-way and round trips. Affordable fares and easy online cab booking from Mumbai to Ahmednagar." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/14.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitoahmednagarcab;